// 💰 ประเภทของรายการเงิน (เชิงบัญชี)
const TRANSACTION_TYPES = {
  INCOME: 'INCOME', // รายรับ
  EXPENSE: 'EXPENSE', // รายจ่าย
  TRANSFER_IN: 'TRANSFER_IN', // โอนเข้า
  TRANSFER_OUT: 'TRANSFER_OUT', // โอนออก
};

// 🧾 ประเภทกิจกรรมทางการเงิน
const ACTIVITY_TYPES = {
  GOLD_SALE: 'GOLD_SALE', // ขายทอง
  GOLD_PURCHASE: 'GOLD_PURCHASE', // ซื้อทอง
  EXPENSE: 'EXPENSE', // รายจ่ายทั่วไป
  INCOME: 'INCOME', // รายรับทั่วไป
  OTHER: 'OTHER', // อื่นๆ
};

// 💳 ช่องทางการชำระเงิน (Payment Channel)
const PAYMENT_METHODS = {
  CASH: 'CASH', // เงินสด
  TRANSFER: 'TRANSFER', // โอนธนาคาร
  CREDIT: 'CREDIT', // เครดิต/บัตร
};

export default { TRANSACTION_TYPES, ACTIVITY_TYPES, PAYMENT_METHODS };
